import * as React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../store/hooks';

const InternalRoute = ({ children }: { children: React.ReactElement }): React.ReactElement => {
    const clientID = useAppSelector((state) => state.auth.clientID);
    const isAllowed = clientID == "SE001";

    return isAllowed ? children : <Navigate to="/" replace />;
};

export default InternalRoute;
